import React from 'react'
import { AuthProvider } from 'react-auth-kit'
import RoutesComponent from './components/Routes'

export default function App() {
  return (
    <AuthProvider authType = {'cookie'}
                  authName={'_auth'}
                  cookieDomain={window.location.hostname}
                  cookieSecure={window.location.protocol === "http:"}>
      <RoutesComponent />
    </AuthProvider>
  );
}
